export interface TextInputOptions {
  maxLength?: number;
  displayLength?: number;
  allowPercentage?: boolean;
  allowSpace?: boolean;
  allowNullValue?: boolean;
}
